import 'arrive';

document.arrive('.block-jobs', {existing: true}, function(){
    const blockName = 'block-jobs';
    const modal = this.querySelector(`.${blockName}__modal`);
    const modalBody = this.querySelector(`.${blockName}__modal-body`);
    const modalClose = this.querySelector(`.${blockName}__modal-close`);
    const subjectField = this.querySelector(`.${blockName}__modal [data-name="subject"] input`);
    const positionsCtas = this.querySelectorAll(`.${blockName}__block-cta`);
    positionsCtas.forEach(function(el){
        el.addEventListener('click', function(){
            modal.classList.add('open');

            if (subjectField) subjectField.value = this.dataset.subject;
        })
    });

    modalClose.addEventListener('click', function(){
        modal.classList.remove('open');
    })


});